import { FPlusCodeContainer } from '@festina-life/fplus'
import { useState } from 'react'

import type { FPlusExpressionValue } from '../../../types/templateModel'
import type { LiteralTypeInformation } from '../../fplusExpression/types'
import { functionDeclarationFromMetadata } from '../../templateFieldsTable/functionHelpers'
import { transformLiteralValuesToFPlusCode } from '../customExpressionToFPlus'
import { FPlusInlineEditContainer } from '../FPlusInlineEditContainer'
import { initialEmptyLiteralValue } from '../helpers'
import { FPlusCustomCollectionEditor } from './FPlusCustomCollectionEditor'
import { FPlusSingleLiteralEditor } from './FPlusSingleLiteralEditor'
import type { CustomEditorProps } from './types'

export const FPlusLiteralExpressionEditor = ({
  onCancel,
  onChangeCode,
  initialHeightPx,
  isTransparent,
  typeInformation,
}: CustomEditorProps<LiteralTypeInformation>) => {
  const [fplusCode, setFPlusCode] = useState(
    typeInformation.value?.length
      ? typeInformation.value
      : [initialEmptyLiteralValue[typeInformation.literalType!] ?? ''],
  )

  const handleCodeChanged = (nextValue: FPlusExpressionValue) => {
    onChangeCode?.(
      typeInformation.functionMetadata
        ? {
            ...nextValue,
            fplusSource: `${functionDeclarationFromMetadata(typeInformation.functionMetadata)} =\n    ${nextValue.fplusSource}`,
          }
        : nextValue,
    )
  }

  return (
    <FPlusInlineEditContainer
      code={transformLiteralValuesToFPlusCode({
        value: fplusCode,
        collectionType: typeInformation.collectionType,
      })}
      onCancel={onCancel}
      initialHeightPx={initialHeightPx}
      onChangeCode={handleCodeChanged}
    >
      <FPlusCodeContainer
        isTransparent={isTransparent}
        className="flex size-full min-h-[inherit] items-center pb-10"
      >
        {typeInformation.collectionType ? (
          <FPlusCustomCollectionEditor
            currentValue={fplusCode}
            onChange={setFPlusCode}
            emptyValue={
              initialEmptyLiteralValue[typeInformation.literalType!] ?? ''
            }
            renderEditor={(value, index) => (
              <FPlusSingleLiteralEditor
                typeInformation={typeInformation}
                currentValue={value}
                onChange={(nextValue) =>
                  setFPlusCode(fplusCode.toSpliced(index, 1, nextValue))
                }
              />
            )}
          />
        ) : (
          <FPlusSingleLiteralEditor
            typeInformation={typeInformation}
            currentValue={fplusCode.at(0) ?? ''}
            onChange={(nextValue) => setFPlusCode([nextValue])}
          />
        )}
      </FPlusCodeContainer>
    </FPlusInlineEditContainer>
  )
}
